import type React from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'
import type { DescriptionType } from '../../Description.h'

import { LabelPurchaseBadge } from 'atoms/Label/Templates'
import { TextBoxMaxLine2Font4xl } from 'atoms/TextBox/Templates'
import { MultiColumnsRowGap } from 'blocks/MultiColumns'
import { LabelsGroupDescription4Line } from 'blocks/MultiColumns/Templates'
import {
  DescriptionAlignItems,
  DescriptionDirection,
  DescriptionJustifyContent,
} from '../../Description.h'
import {
  LiveEventDescriptionColumnSC,
  LiveEventDescriptionSC,
  TitleWrapper,
} from '../../Description.styled'

export interface IPartnerProductDetailsPageDescription extends DescriptionType {
  title: ITextBoxProps['title']
  daysTitleTimer?: ITextBoxProps['daysTitle']
  hoursTitleTimer?: ITextBoxProps['hoursTitle']
  minutesTitleTimer?: ITextBoxProps['minutesTitle']
  secondsTitleTimer?: ITextBoxProps['secondsTitle']
  rowGap?: MultiColumnsRowGap
  children?: React.ReactNode
  titleTimer?: string
  completionDate?: string
  onTimerCompleted?: () => void
  onClickMore?: (args: any) => void
}

export const PartnerProductDetailsPageDescription = ({
  labels: _unused1,
  text,
  stars,
  directors,
  title,
  rowGap = MultiColumnsRowGap.INDENT_60,
  children,
  titleTimer: _unused2,
  daysTitleTimer: _unused3,
  hoursTitleTimer: _unused4,
  minutesTitleTimer: _unused5,
  secondsTitleTimer: _unused6,
  completionDate: _unused7,
  paid,
  onTimerCompleted: _unused8,
  onClickMore,
  purchaseTitle,
  rented,
  ...rest
}: IPartnerProductDetailsPageDescription) => {
  return (
    <LiveEventDescriptionSC
      {...rest}
      width={100}
      direction={DescriptionDirection.Row}
      alignItems={DescriptionAlignItems.FlexEnd}
      justifyContent={DescriptionJustifyContent.SpaceBetween}
      rented={rented}
    >
      <LiveEventDescriptionColumnSC>
        {(paid || (rented && purchaseTitle)) && (
          <TitleWrapper>
            <LabelPurchaseBadge title={rented ? purchaseTitle : ''} />
          </TitleWrapper>
        )}
        <TitleWrapper>
          <TextBoxMaxLine2Font4xl title={title} />
        </TitleWrapper>
        <LabelsGroupDescription4Line
          more={rest.more}
          titleButton={rest.titleButton}
          fullInformation={rest.fullInformation}
          textDirectors={directors}
          textStars={stars}
          text={text}
          width={rest.width || 100}
          popupWidth={rest.popupWidth}
          rowGap={rowGap}
          onClickMore={onClickMore}
        >
          {children}
        </LabelsGroupDescription4Line>
      </LiveEventDescriptionColumnSC>
    </LiveEventDescriptionSC>
  )
}
